const isFrenchBrowser = () => navigator.language.toLowerCase().startsWith("fr");

export const DocumentationHomeUrl = "https://pathta.gitbook.io/pathta-docs";
export const DocumentationHomeUrlFr = "https://pathta.gitbook.io/pathta-docs/pathta-documentation";

export const CreateFirstPathTutorialUrl = "https://pathta.gitbook.io/pathta-docs/getting-started/create-your-first-path";
export const CreateFirstPathTutorialUrlFr = "https://pathta.gitbook.io/pathta-docs/pathta-documentation/guide-de-demarrage/creez-votre-premier-path";

export function getLocalizedDocumentationUrl(defaultUrl: string, frenchUrl: string): string {
  return isFrenchBrowser() ? frenchUrl : defaultUrl;
}
